export const LIST_PAYMENT_METHODS = "listAllPaymentMethods";
export const ADD_PAYMENT_METHOD = "addNewPaymentMethod";
export const CONFIRM_PAYMENT = "confirmPayment";
export const DELETE_PAYMENT_METHOD = "deletePaymentMethod";
export const MARK_AS_DEFAULT = "markAsDefaultPaymentMethod";
export const UPDATE_PAYMENT_DETAIL = "updatePaymentDetail";